import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'do0089',
    ecrans: ['00-2']
});
